import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

const preloadedState = (typeof window !== 'undefined' && window.__PRELOADED_STATE__) ? window.__PRELOADED_STATE__ : {};

export default (initialState = preloadedState) => configureStore({
    reducer: rootReducer,
    preloadedState: initialState
});
